import { ButtonLink } from "@kds-web/button";
import { GalleryIcon } from "@kds-web/icons";
import { Modal } from "@kds-web/modal";
import type { JSX } from "react/jsx-runtime";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

function AdGalleryModal({ isOpen, onClose }: Props): JSX.Element {
  return (
    <Modal
      open={isOpen}
      title="Warum Galerie buchen?"
      actions={[
        <ButtonLink
          key={1}
          label="Jetzt buchen"
          href="/m-meine-anzeigen.html"
        />,
      ]}
      size="medium"
      onClose={onClose}
    >
      <div className="flex">
        <div className="w-1/2 min-w-[50%]">
          <img
            className="max-w-full"
            src="https://static.kleinanzeigen.de/static/img/features-payment/feature-desc-rb-gallery.859ot4atbyjj.png"
            alt=""
          />
        </div>
        <div className="mb-small ml-small">
          <div className="mb-small flex items-center gap-medium ">
            <div>
              <GalleryIcon size="xlarge" />
            </div>
            <h3 className="text-title4">
              Unübersehbar auf der Startseite!
              <br />
              Erhalte bis zu 15x mehr Anfragen!
            </h3>
          </div>
          <ul className="my-medium list-disc pl-large leading-[130%]">
            <li className="my-xsmall">
              Deine Anzeige rotiert mit anderen Galerieanzeigen für 10 Tage auf
              der Startseite
            </li>
            <li className="my-xsmall">
              Geeignet für hochpreisige oder außergewöhnliche Produkte sowie
              Dienstleistungen, Immobilien und Jobs
            </li>
            <li className="my-xsmall">
              <strong>Tipp: </strong>Um die Effektivität zusätzlich zu erhöhen,
              achte insb. auf ein aussagekräftiges Bild der Anzeige
            </li>
          </ul>
        </div>
      </div>
    </Modal>
  );
}

export default AdGalleryModal;
